import SideDrawer from '@payaca/components/sideDrawer/SideDrawer';
import {
  PublicHydratedEntityTemplate,
  TemplatableEntity,
} from '@payaca/types/entity-templates';
import { FC, type JSX } from 'react';
import EntityTemplateReadView from '../entityTemplateReadView/EntityTemplateReadView';
import './EntityTemplateReadDrawer.sass';

type Props = {
  entityTemplate: PublicHydratedEntityTemplate<TemplatableEntity>;
  onDeleteEntityTemplateSuccess?: () => void;
  onUpdateEntityTemplateSuccess?: (
    updatedEntityTemplate: PublicHydratedEntityTemplate<TemplatableEntity>
  ) => void;
  isOpen: boolean;
  onClose?: () => void;
  allowModifyTemplateNameDescription?: boolean;
};

const EntityTemplateReadDrawer: FC<Props> = ({
  entityTemplate,
  onDeleteEntityTemplateSuccess,
  onUpdateEntityTemplateSuccess,
  isOpen,
  onClose,
  allowModifyTemplateNameDescription,
}: Props): JSX.Element | null => {
  return (
    <SideDrawer
      isOpen={isOpen}
      onClose={onClose}
      className="entity-template-read-drawer"
    >
      {entityTemplate && (
        <EntityTemplateReadView
          allowModifyTemplateNameDescription={
            allowModifyTemplateNameDescription
          }
          initialEntityTemplate={entityTemplate}
          onUpdateEntityTemplateSuccess={onUpdateEntityTemplateSuccess}
          onDeleteEntityTemplateSuccess={onDeleteEntityTemplateSuccess}
        />
      )}
    </SideDrawer>
  );
};
export default EntityTemplateReadDrawer;
